module.exports = __webpack_public_path__ + "img/f35f953.jpg";